import { Vue, Component } from 'vue-property-decorator';

@Component
export default class UpdateMixin extends Vue {
  public refreshing = false;
  public registration;
  public updateExists = false;

  public updateAvailable(event) {
    this.registration = event.detail;
    this.updateExists = true;
  }

  // Called when the user accepts the update
  public refreshApp() {
    this.updateExists = false;
    // Make sure we only send a 'skip waiting' message if the SW is waiting
    if (!this.registration || !this.registration.waiting) {
      return;
    }
    // Send message to SW to skip the waiting and activate the new SW
    this.registration.waiting.postMessage('skipWaiting');
  }

  public created() {
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, {
      once: true
    });

    // Refresh all open app tabs when a new service worker is installed.
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) {
          return;
        }
        this.refreshing = true;
        // Here the actual reload of the page occurs
        window.location.reload();
      });
    }
  }
}
